import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useOpenTrace from '../../../../hooks/use-open-trace';
import useRefocusOnRemoval from '../../../../hooks/use-refocus-on-removal';
import DecryptAllButton, { type DecryptAction } from '../../../decrypt-all-button';

// Smaller than the header's, to sit in the tab row.
const BUTTON_CLASS_NAME = 'h-6! px-2! text-label-3';
type TabBarActionsProps = {
  onboarding: EntityOnboarding;
  decrypt?: DecryptAction | 'pending';
  /** Takes focus when an action goes while focused, like once the tabs unstick. */
  onRemovedWhileFocused: () => void;
};

/** The header's main actions, which the tabs carry once they stick and cover the header. */
const TabBarActions = t0 => {
  const $ = _c(14);
  const {
    onboarding,
    decrypt,
    onRemovedWhileFocused
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const openTrace = useOpenTrace();
  const traceFocusHandlers = useRefocusOnRemoval(onRemovedWhileFocused);
  const hasDecrypt = decrypt !== undefined && decrypt !== "pending";
  if (!hasDecrypt && !onboarding.hasGraphTrace) {
    return null;
  }
  let t2;
  if ($[1] !== decrypt || $[2] !== hasDecrypt || $[3] !== onRemovedWhileFocused) {
    t2 = hasDecrypt && <DecryptAllButton decrypt={decrypt} onRemovedWhileFocused={onRemovedWhileFocused} className={BUTTON_CLASS_NAME} />;
    $[1] = decrypt;
    $[2] = hasDecrypt;
    $[3] = onRemovedWhileFocused;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onboarding.hasGraphTrace || $[6] !== onboarding.id || $[7] !== openTrace || $[8] !== t || $[9] !== traceFocusHandlers) {
    t3 = onboarding.hasGraphTrace && <Button variant="secondary" size="compact" className={BUTTON_CLASS_NAME} onClick={event => openTrace(event, onboarding.id)} {...traceFocusHandlers}>{t(_temp)}</Button>;
    $[5] = onboarding.hasGraphTrace;
    $[6] = onboarding.id;
    $[7] = openTrace;
    $[8] = t;
    $[9] = traceFocusHandlers;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="absolute inset-y-0 right-5 flex items-center gap-2 pt-1 transition-[opacity,translate,filter] duration-300 ease-out starting:translate-y-1 starting:opacity-0 starting:blur-[2px] motion-reduce:transition-none">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default TabBarActions;
function _temp($) {
  return $.header.openTrace;
}